const useTranslations = (): {
  getTranslation: (translationObject: Record<string, string | Array<string>> | undefined) => string | Array<string>
} => {
  const { $i18n: i18n } = useNuxtApp()
  const fallbackLocale = i18n.fallbackLocale.value as string
  const getTranslation = (translationObject: Record<string, string | Array<string>> | undefined): string | Array<string> => {
    if (!translationObject || (!Array.isArray(translationObject) && (typeof translationObject !== 'object'))) {
      console.warn('Object to translate is either not defined or in the wrong format.', 'translationObject:', translationObject)
      return ''
    }
    if ((Array.isArray(translationObject) && !translationObject.length) || (typeof translationObject === 'object' && Object.keys(translationObject).length === 0)) {
      console.warn('Translation object is empty.')
      return ''
    }
    const translation = translationObject[i18n.locale.value] || translationObject[fallbackLocale]
    if (!translation) {
      console.warn('No translation found', 'translationObject:', translationObject, 'locale:', i18n.locale.value, 'fallbackLocale:', fallbackLocale)
      return ''
    }
    return translation
  }
  return {
    getTranslation
  }
}
export {
  useTranslations
}
